import { Component, Input, OnInit, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-shoppingcart',
    templateUrl: './shoppingcart.component.html',
    styleUrls: ['./shoppingcart.component.scss']
})
export class ShoppingcartComponent implements OnInit {
    constructor(

    ) {}

    ngOnInit() {

    }

}




// WEBPACK FOOTER //
// ./src/app/shared/components/shoppingcart/shoppingcart.component.ts